/** Every REST route lives under this prefix. A breaking change gets /api/v2 alongside it. */
export const API_PREFIX = '/api/v1';

/** All user-facing times are shown in this zone, whatever the browser or server is set to. */
export const DISPLAY_TIME_ZONE = 'Europe/London';

/** Devices not seen for longer than these are drawn grey, then red. */
export const STALE_AFTER_MS = 60 * 60 * 1000;
export const VERY_STALE_AFTER_MS = 24 * 60 * 60 * 1000;

/** Pairing codes: 6 characters, no 0/O/1/I/L so they can't be misread. */
export const PAIRING_CODE_LENGTH = 6;
export const PAIRING_CODE_ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
export const PAIRING_CODE_TTL_MS = 10 * 60 * 1000;

/** Default location history retention, in days. */
export const DEFAULT_RETENTION_DAYS = 30;
